import React, { useEffect, useState, useContext } from "react"

import { Context } from "../../../context/app-context"

import GenericModal from "../../templates/generic-modal/generic-modal"
import ModalLoading from "../../molecules/modal-loading/modal-loading"
import ModalLogin from "../../molecules/modal-login/modal-login"
import ModalRedeem from "../../molecules/modal-redeem/modal-redeem"
import ModalPoints from "../../molecules/modal-points/modal-points"
import ModalEndGame from "../../molecules/modal-endgame/modal-endgame"
import ModalEducational from "../../molecules/modal-educational/modal-educational"

export default function ModalViewer({ modal }) {
  const initialStateModal = null
  const [activityStep, setActivityStep] = useState(initialStateModal)
  const { dispatch } = useContext(Context)

  const noClose = modal?.props?.noClose

  const handleClose = () => {
    setActivityStep(null)
    dispatch({
      type: "set-context",
      payload: {
        modalActive: null
      }
    })
    if (modal?.handleClose) modal.handleClose()
  }

  useEffect(() => {
    if (modal && modal.type !== undefined) {
      const modalProps = { ...modal?.props }
      const stepsComponents = {
        loading: <ModalLoading {...modalProps} />,
        unauthenticated: <ModalLogin {...modalProps} />,
        redemption: <ModalRedeem {...modalProps} />,
        endGame: <ModalEndGame {...modalProps} />,
        userTop: <ModalPoints {...modalProps} />,
        educational: <ModalEducational {...modalProps}/>
      }[modal.type]
      setActivityStep(stepsComponents)
    }
    return () => {
      setActivityStep(initialStateModal)
    }
  }, [modal])

  return (
    activityStep && (
      <GenericModal handleClose={handleClose} noClose={noClose}>
        {activityStep}
      </GenericModal>
    )
  )
}
